import { Link } from 'react-router-dom';
import { BookOpen, ArrowUpRight, Clock } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import useSEO from '../hooks/useSEO';
import useJsonLd from '../hooks/useJsonLd';
import { PAGE_SEO, SITE_CONFIG } from '../data/seoConfig';
import { RESOURCES } from '../mock';

export default function Resources() {
  useSEO(PAGE_SEO.resources);

  useJsonLd('resources-breadcrumb', {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_CONFIG.url },
      { '@type': 'ListItem', position: 2, name: 'Resources', item: `${SITE_CONFIG.url}/resources` },
    ],
  });

  return (
    <div>
      <PageHeader
        eyebrow='Resources'
        title={<><span className='text-white'>Marketing playbooks from our</span> <span className='text-brand-gradient'>senior operators</span></>}
        description='Free digital marketing resources: SEO checklists, LLMO playbooks, paid media benchmarks, and growth frameworks used by the Ransen team.'
        crumbs={[{ label: 'Resources' }]}
      />
      <section className='py-16'>
        <div className='max-w-6xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-5'>
          {RESOURCES.map((r) => (
            <a key={r.title} href='#' className='glass-card rounded-2xl p-6 group flex flex-col'>
              <div className='flex items-center justify-between'>
                <div className='inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-violet-500/10 border border-violet-500/25 text-violet-200 text-[11px] tracking-wider uppercase font-semibold'>
                  <BookOpen className='w-3 h-3'/> {r.category}
                </div>
                <ArrowUpRight className='w-5 h-5 text-white/30 group-hover:text-violet-300 transition-colors'/>
              </div>
              <h3 className='mt-5 font-heading text-[19px] font-semibold text-white leading-snug'>{r.title}</h3>
              <div className='mt-auto pt-6 flex items-center justify-between text-white/45 text-[12.5px]'>
                <span className='inline-flex items-center gap-1.5'><Clock className='w-3.5 h-3.5'/> {r.read}</span>
                <span className='text-violet-300'>{r.tag}</span>
              </div>
            </a>
          ))}
        </div>
        <div className='mt-16 max-w-2xl mx-auto text-center'>
          <h3 className='font-heading text-2xl font-bold text-white'>Get new playbooks in your inbox</h3>
          <p className='mt-3 text-white/60 text-[14.5px]'>Monthly. No fluff. Written by our senior team.</p>
          <form onSubmit={(e) => { e.preventDefault(); }} className='mt-6 flex flex-col sm:flex-row gap-3'>
            <input type='email' required placeholder='you@company.com' className='flex-1 px-4 py-3 rounded-full bg-white/5 border border-white/10 text-white placeholder:text-white/35 focus:outline-none focus:border-violet-500/60' />
            <button type='submit' className='btn-primary text-white text-sm font-semibold px-6 py-3 rounded-full'>Subscribe</button>
          </form>
        </div>
      </section>
      <div className='py-6 text-center'>
        <Link to='/contact' className='text-violet-300 text-sm'>Or book a strategy call →</Link>
      </div>
    </div>
  );
}
